// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4d83ed54","213":"d6bee055","239":"87a47b0f","453":"2bc9f1c2","732":"b25d4c34"}[chunkId] + ".chunk.js";
};